(() => {
  const CLOSE_TIMEOUT_MS = 650;
  const DIALOG_CLOSE_SELECTOR = [
    '.cart-drawer__close-button',
    '.predictive-search__close-modal-button',
    '.quick-add-modal__close',
    'dialog[open][on\\:click*="closeDialogOnClickOutside"]'
  ].join(',');
  const DRAWER_HISTORY_KEYS = [
    'cartDrawerOpen',
    'cartDrawerScrollY',
    '__gurbakirDrawer',
    '__gurbakirDrawerSession'
  ];
  const pendingDialogCloses = new WeakMap();

  function lockedScrollY() {
    const lockedTop = Number.parseFloat(document.body.style.top);
    if (document.body.style.position === 'fixed' && Number.isFinite(lockedTop)) return Math.abs(lockedTop);
    return window.scrollY;
  }

  function clearDrawerHistoryState() {
    const state = history.state;
    if (!state || typeof state !== 'object') return;

    const next = { ...state };
    let changed = false;
    for (const key of DRAWER_HISTORY_KEYS) {
      if (!(key in next)) continue;
      delete next[key];
      changed = true;
    }

    if (changed) history.replaceState(Object.keys(next).length > 0 ? next : null, '', location.href);
  }

  function releaseDocumentLock(scrollY) {
    if (document.querySelector('dialog[open]')) return;

    const wasFixed = document.body.style.position === 'fixed';

    document.body.style.removeProperty('width');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.documentElement.removeAttribute('scroll-lock');

    if (!wasFixed || !Number.isFinite(scrollY) || scrollY < 0) return;

    window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
  }

  function forceCloseDialog(dialog, scrollY) {
    pendingDialogCloses.delete(dialog);

    if (dialog.open) {
      try {
        dialog.close();
      } catch (_error) {
        dialog.removeAttribute('open');
      }
    }

    dialog.classList.remove('dialog-closing');
    dialog.style.removeProperty('animation');
    dialog.style.removeProperty('--dialog-drawer-closing-animation');
    releaseDocumentLock(scrollY);
    clearDrawerHistoryState();
  }

  function resetHeaderDrawer() {
    document.querySelectorAll('header-drawer').forEach((component) => {
      component.querySelectorAll('details[open]').forEach((details) => {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      component.querySelectorAll('.menu-drawer--has-submenu-opened').forEach((drawer) => {
        drawer.classList.remove('menu-drawer--has-submenu-opened');
      });
    });
  }

  function resetCustomDrawers() {
    const listRoot = document.getElementById('gb-listem-root');
    listRoot?.classList.remove('is-open');
    listRoot?.querySelector('.gb-listem__drawer')?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gb-listem-scroll-lock');

    document.getElementById('chat-drawer')?.classList.remove('active');
    document.getElementById('chat-drawer')?.setAttribute('aria-hidden', 'true');
    document.getElementById('chat-drawer-overlay')?.classList.remove('active');
    document.getElementById('chat-widget-btn')?.setAttribute('aria-expanded', 'false');
  }

  function resetTransientUi({ clearHistory = true } = {}) {
    const scrollY = lockedScrollY();

    document.querySelectorAll('dialog[open]').forEach((dialog) => forceCloseDialog(dialog, scrollY));
    resetHeaderDrawer();
    resetCustomDrawers();
    releaseDocumentLock(scrollY);

    if (clearHistory) clearDrawerHistoryState();
  }

  function scheduleDialogCloseFallback(dialog) {
    const token = {};
    const scrollY = lockedScrollY();
    pendingDialogCloses.set(dialog, token);

    window.requestAnimationFrame(() => {
      if (pendingDialogCloses.get(dialog) !== token || !dialog.open) return;
      if (!dialog.classList.contains('dialog-closing')) forceCloseDialog(dialog, scrollY);
    });

    window.setTimeout(() => {
      if (pendingDialogCloses.get(dialog) !== token || !dialog.open) return;
      forceCloseDialog(dialog, scrollY);
    }, CLOSE_TIMEOUT_MS);
  }

  function hasStaleUi() {
    return Boolean(
      document.body.style.position === 'fixed' ||
        document.documentElement.hasAttribute('scroll-lock') ||
        document.documentElement.classList.contains('gb-listem-scroll-lock') ||
        document.querySelector('dialog[open].dialog-closing') ||
        document.querySelector('header-drawer details[open]:not(.menu-open)') ||
        document.querySelector('#gb-listem-root.is-open, #chat-drawer.active, #chat-drawer-overlay.active')
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (!target) return;

      const navigationLink = target.closest(
        'dialog[open] a[href], header-drawer details.menu-open a[href], #gb-listem-root.is-open a[href], #chat-drawer.active a[href]'
      );
      if (navigationLink) {
        resetTransientUi();
        return;
      }

      const closeControl = target.closest(DIALOG_CLOSE_SELECTOR);
      const dialog = closeControl?.closest('dialog');
      if (dialog instanceof HTMLDialogElement && dialog.open) scheduleDialogCloseFallback(dialog);
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (event.target instanceof HTMLDialogElement) pendingDialogCloses.delete(event.target);
    },
    true
  );

  document.addEventListener(
    'cancel',
    (event) => {
      if (event.target instanceof HTMLDialogElement) scheduleDialogCloseFallback(event.target);
    },
    true
  );

  window.addEventListener('pagehide', () => resetTransientUi({ clearHistory: false }), { capture: true });
  window.addEventListener(
    'pageshow',
    (event) => {
      if (event.persisted || hasStaleUi()) resetTransientUi();
    },
    { capture: true }
  );
  window.addEventListener(
    'popstate',
    () => {
      window.requestAnimationFrame(() => {
        if (document.querySelector('cart-drawer-component dialog[open]')) return;
        resetTransientUi();
      });
    },
    { capture: true }
  );
})();

